var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("order-edit", {
        ref: "edit",
        attrs: { show: _vm.orderEditShow, "edit-id": _vm.orderEditId },
        on: { close: _vm.closeEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }